export default Object.freeze({
  list: [],
  info: {},
  selectedCategory: null,
  loading: false,
});
